<template>
  <div class="position-fixed line-buttons">
    <a href="/cita-de-servicio" id="calendar" class="calendar">
      <img src="@/assets/images/calendar.png">
    </a>
    <a href="tel:+6677303531" id="phone" class="phone">
      <img src="@/assets/images/phone.png">
    </a>
    <a href="https://www.facebook.com/grupofelixmx/" id="messenger" class="messenger">
      <img src="@/assets/images/messenger.png">
    </a>
    <a href="https://api.whatsapp.com/send?phone=6677912653&text=Hola!%20Me%20interesa%20obtener%20informaci%C3%B3n%20sobre%20un%20veh%C3%ADculo%20de%20grupo%20Felix" id="whatsapp" class="whatsapp">
      <img src="@/assets/images/whatsapp.png">
    </a>
  </div>
</template>

<script>
export default {
  name: 'Social'
}
</script>

<style scoped>

</style>
